import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { fetchLeadStatuses } from "../../api/Lead.api";


interface StatusState {
  data: string[];
  loading: boolean;
}

const initialState = {
  data: [],
  loading: false,
};

export const getStatus = createAsyncThunk(
  "kanban/getStatus",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchLeadStatuses();
      return data;
    } catch (error: any) {
      return rejectWithValue(error?.message || "Failed to fetch Kanban data");
    }
  }
);

const statusSlice = createSlice({
  name: "status",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getStatus.rejected, (state, action) => {
        state.loading = false;
      });
  },
});
export const selectStatus = (state: { status: StatusState }) => state.status;

export default statusSlice.reducer;
